export const en = {
  titulo: 'CACIN: Computer Aided Cataloguing of INcunabula',
  cancel: 'Cancel',
  save: 'Save',
  editButton: 'Edit',
  accept: 'Accept',
  closeButton: 'Close',
  filters: 'Filters',
  loading: 'Loading...',
  select: 'Select this option',

  NavBar: {
    menu: 'Menu',
    booksList: 'Books List',
    office: 'Printing Offices List',
    editDelete: 'Edit/Delete Books',
    contactUs: 'About',

  },

  contactUs: {
    title: "",
    welcome: "This website provides access to a catalogue of incunabula with the ability to automatically identify the typeface used in the printed text by applying the Proctor-Haebler method, which classifies typefaces based on the height of the lines and the shape of the special letters. The identification of the typeface allows the incunabulum to be assigned to the printing office that created that typeface, as well as locating its printing spatially and temporally.",
    support: ").",
    supportLink: "(pedraza@unizar.es)",
    email: "The list of incunabula and printing offices is directly accessible. To obtain access to the catalogue editing functions, please contact the professors Manuel José Pedraza Gracia  ",
    emailLink: "(pedraza@unizar.es)",
    emailText: "and Javier Nogueras Iso ",
    emailLink2: "(jnog@unizar.es)",
    media: "Tutorial Video",
    mediaLink: "https://youtu.be/v49EJ7qHKJ4?si=3QF0zzW1TZ758qRa",
    medaiText: ">",
    repoText: "GitHub Repository",
    repoLink: "https://github.com/IAAA-Lab/CACIN",
    reference: "References:",
    referenceText: "J. Lacasta, J. Nogueras-Iso, F.J. Zarazaga-Soria, M.J. Pedraza-Gracia (2022).  ",
    referenceLink: "Tracing the origins of incunabula through the automatic identification of fonts in digitised documents. ",
    referenceText2: "Multimedia Tools and Applications, 81:40977–40991."
  },
    home: {
    title: "",
    welcome: "This website provides access to a catalogue of incunabula with the ability to automatically identify the typeface used in the printed text by applying the Proctor-Haebler method, which classifies typefaces based on the height of the lines and the shape of the special letters. The identification of the typeface allows the incunabulum to be assigned to the printing office that created that typeface, as well as locating its printing spatially and temporally.",
    support: ").",
    supportLink: "(pedraza@unizar.es)",
    email: "The list of incunabula and printing offices is directly accessible. To obtain access to the catalogue editing functions, please contact the professors Manuel José Pedraza Gracia  ",
    emailLink: "(pedraza@unizar.es)",
    emailText: "and Javier Nogueras Iso ",
    emailLink2: "(jnog@unizar.es)",
    media: "Tutorial Video",
    mediaLink: "https://youtu.be/v49EJ7qHKJ4?si=3QF0zzW1TZ758qRa",
    medaiText: ">",
    repoText: "GitHub Repository",
    repoLink: "https://github.com/IAAA-Lab/CACIN",
    reference: "References:",
    referenceText: "J. Lacasta, J. Nogueras-Iso, F.J. Zarazaga-Soria, M.J. Pedraza-Gracia (2022).  ",
    referenceLink: "Tracing the origins of incunabula through the automatic identification of fonts in digitised documents. ",
    referenceText2: "Multimedia Tools and Applications, 81:40977–40991."
  },
    footer: {
    projectReference: "This web site is part of the R&D project T59_23R supported by the Aragon Regional Government (Spain).",
    universityName: "Advanced Information Systems Laboratory (Grupo de Sistemas de Información Avanzados)",
  },
  
  login: {
    log: 'Log in',
    logout: 'Log out',
    info: 'Log in to access the system',
    email: 'Email address',
    user: 'User',
    password: 'Password',
    error: 'Email and password are required',
    logError: 'Login failed. Please try again.',
    check: 'Checking credentials...',
  },

  booksTable: {
    addBook: 'Add book',
    info: 'Incunabula information',
    placeholderTable: 'Search books by title...',
    title: 'Title',
    id: 'ID',
    creator: 'Author',
    fontType: 'Font Type',
    publisher: 'Publisher',
    printingOffice: 'Printing Office',
    show: 'Number of results to show: ',
  },

  filters: {
    title: 'Filters',
    creator: 'Author',
    publisher: 'Publisher',
    printingOffice: 'Printing Office',
    fontType: 'Font Type',
    clear: 'Clean filters',
    search: 'Search',
  },

  editDelete: {
    info: 'Edit or delete incunabulas in the system',
    actions: 'Actions',
  },

  bookToDelete: {
    modalTitle: 'Are you absolutely sure?',
    modalInfo: 'This action cannot be undonde. This will permanently delete the incunabula and remove the data from our servers.',
    cancel: 'Cancel',
    yes: 'Yes, delete incunabula',
  },

  edit: {
    title: 'Edit',
    info: 'Edit incunabula ',
    bookId: 'ID',
    bookTitle: 'Title',
    bookCreator: 'Author',
    bookPublisher: 'Publisher',
    bookPrintingOffice: 'Printing Office',
    bookFontType: 'Font Type',
    file: 'File',
    fileError: 'The file format must be .tiff or .tif',
    automaticRecognition: 'Automatic recognition',
    selectPrintingOffice: 'Select a printing office',
    selectFontType: 'Select a font type',
    errorSelectFont: 'First you must select a printing office',
    date: 'Publication year',
    location: 'Publication location',
  },

  add: {
    title: 'Add incunabula',
    info: 'Add a new incunabula ',
    option: 'Option ',
    bookTitle: 'Title',
    bookCreator: 'Author',
    bookPublisher: 'Publisher',
    bookPrintingOffice: 'Printing Office',
    bookFontType: 'Font Type',
  },

  modalAdd: {
    title: 'Incunabula added',
    info: 'The incunabula has been added to the system',
    bookId: 'ID',
  },

  modalImage: {
    title: 'Incunabula image',
    info: 'Image of the incunabula'
  },

  incunabula: {
    info: 'Incunabula details',
  },

  font: {
    title: 'Font Types',
    info: 'Font type details',
    fontHeight: 'Font Height',
    id: 'ID',
    fontOffice: 'Printing Office',
    mShape: 'M Shape',
    fontImage: 'Font Image',
  },


  newBookModal: {
    title: 'New incunabula added',
    info: 'The incunabula has been added to the system',
  },

  printingOffice: {
    id: 'ID',
    title: 'Printing Office information',
    name: 'Name',
    alternativeName: 'Alternative Name',
    foundedYear: 'Founded Year',
    closedYear: 'Closed Year',
    location: 'Location',
    placeholderTable: 'Search printing offices by name...',
    show: 'Number of results to show: ',
    time: 'Time',
    search: 'Search printing offices',

  },



}
